import { cn } from '@/lib/utils';

const DEFAULT_SIZES =
  '(max-width: 640px) 100vw, (max-width: 1152px) 90vw, 1152px';

export type ResponsiveImageProps = {
  src: string;
  alt: string;
  width?: number;
  height?: number;
  sizes?: string;
  srcSet?: string;
  priority?: boolean;
  fill?: boolean;
  className?: string;
};

/**
 * Evidence transport: intrinsic dimensions, lazy loading, stable layout.
 */
export function ResponsiveImage({
  src,
  alt,
  width,
  height,
  sizes = DEFAULT_SIZES,
  srcSet,
  priority = false,
  fill = false,
  className,
}: ResponsiveImageProps) {
  const loading = priority ? 'eager' : 'lazy';

  if (fill) {
    return (
      <img
        src={src}
        alt={alt}
        width={width}
        height={height}
        sizes={sizes}
        srcSet={srcSet}
        loading={loading}
        decoding="async"
        className={cn('absolute inset-0 h-full w-full object-cover', className)}
      />
    );
  }

  return (
    <img
      src={src}
      alt={alt}
      width={width}
      height={height}
      sizes={sizes}
      srcSet={srcSet}
      loading={loading}
      decoding="async"
      className={cn('h-auto max-w-full', className)}
    />
  );
}
